import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardStyle } from './Card';
import { v4 } from 'uuid';
import { Guide } from '../guide';
import { Profile } from '../profile';

export const empty: Guide = {
  id: v4(),
  name: '',
  public_url: null,
  company_id: null,
  description_text: null,
  image_identifier: null,
  method: null,
  grind_size: null,
  steps: [],
  user: null,
  user_id: null,
  shared: true,
  temperature: 0,
  temperature_unit: 'Celsius',
};

type Props = {
  profile: Profile;
};

export const newGuide = (profile: Profile) => ({
  ...empty,
  company_id: profile.company_id,
  user_id: profile.id,
  user: {
    name: profile.name,
    image_url: profile.image_url,
    id: profile.id,
  },
});

export default (props: Props) => (
  <Card
    className={`${CardStyle.Default} animated fadeIn`}
  >
    <Link
      to={{
        pathname: '/guides/edit/new',
        state: { guide: newGuide(props.profile), mode: 'new' },
      }}
      className="link black"
    >
      <div className="">
        <img
          className="w4 h4 br-100 dib"
          src="/images/methods/add.png"
          alt="Add a "
        />
      </div>
      <h6 className="h2 ma0 mt3 lh-copy f6 ttu black-70">Add a new Guide</h6>
    </Link>
  </Card>
);
